import React, { useEffect, useRef } from "react";
import { Box } from "@material-ui/core";

import { useStyles } from "./InputPin.style";

interface InputPinProps {
  pin?: string;
  pinLength: number;

  onPinChange?: (pin: string) => void;
}

export function InputPin(props: InputPinProps) {
  const classes = useStyles(props);
  const hiddenInputRef = useRef(null);
  // Props
  const { pinLength, onPinChange, pin } = props;

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    const re = /^[0-9\b]+$/;
    let currentVal: string = event.currentTarget.value;

    if (currentVal === "" || re.test(currentVal)) {
      // Handle callback
      if (onPinChange !== null && onPinChange !== undefined) {
        onPinChange(currentVal);
      }
    }
  };

  const renderPinDots = () => {
    if (pin) {
      return pin.split("").concat(Array(pinLength - pin.length).fill(""));
    }

    return Array(pinLength).fill("");
  };

  const handleOnClick = () => {
    hiddenInputRef.current.focus();
  };

  useEffect(() => {
    hiddenInputRef.current.focus();
  }, []);

  return (
    <Box className={classes.root} onClick={handleOnClick}>
      <div className={classes.hiddenInput}>
        <input
          type="text"
          ref={hiddenInputRef}
          value={pin}
          onChange={handleChange}
          maxLength={pinLength}
        />
      </div>
      <div className={classes.pinWrapper}>
        <Box
          component="div"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          {renderPinDots().map((item, index) => {
            let className = `pinDot ${item.length !== 0 ? "selected" : ""}`;
            return <span className={className} key={index} />;
          })}
        </Box>
      </div>
    </Box>
  );
}
